module.exports = __webpack_public_path__ + "img/welcome.8216ce8e.png";